var site = site || {};
var generic = generic || {};

(function ($) {
  function initAddCart() {
    var serviceBus = window.GlobalServiceBus;
    var serviceBusTopics = window.ServiceBusTopics;

    site.addToCart = function (args) {
      var skuBaseId;
      var params;
      var matchResult;
      var catBaseId = '';

      if (args.skuBaseId) {
        skuBaseId = args.skuBaseId;
      } else {
        return null;
      }

      if (args.skuData && args.skuData.PARENT_CAT_ID) {
        matchResult = args.skuData.PARENT_CAT_ID.match('[0-9]+');

        if (matchResult) {
          catBaseId = matchResult[0];
        }
      }

      params = {
        skus: Array.isArray(skuBaseId) ? skuBaseId : [skuBaseId],
        itemType: 'cart',
        INCREMENT: 1,
        CAT_BASE_ID: catBaseId
      };

      generic.checkout.cart.updateCart({
        params: params,
        onSuccess: function (r) {
          var resultData = r.getData();

          $(document).trigger('addToCart.success', [resultData]);
        },
        onFailure: function (ss) {
          var errors = ss.getMessages();
          var resultData = ss.getData();

          $(document).trigger('addToCart.failure', [errors, resultData]);
        }
      });
    };

    $(document).on('perlgem.cart.addItem', function (e, skuBaseId, pl) {
      var args = {};
      var frequency;
      var payload = typeof pl !== 'undefined' ? pl : {};

      // Set sku base id
      args.skuBaseId = skuBaseId;

      // Set quantity
      args.qty = payload.quantity ? payload.quantity : 1;

      // Set replenishment if it exists
      frequency = payload.replenishment ? payload.replenishment : null;

      if (frequency) {
        args.REPLENISHMENT_FREQ = frequency;
      }

      site.addToCart(args);
    });

    $(document).on('addToCart.success', function () {
      var isServiceBusValid = serviceBus && serviceBus.emit;
      var isServiceBusTopicsValid = serviceBusTopics &&
        serviceBusTopics.events &&
        serviceBusTopics.events.CART_UPDATED;

      if (isServiceBusValid && isServiceBusTopicsValid) {
        serviceBus.emit(
          serviceBusTopics.events.CART_UPDATED
        );
      }
    });

    $(document).on('addToCart.failure', function () {
      var isServiceBusValid = serviceBus && serviceBus.emit;
      var isServiceBusTopicsValid = serviceBusTopics &&
        serviceBusTopics.events &&
        serviceBusTopics.events.CART_FAILURE;

      if (isServiceBusValid && isServiceBusTopicsValid) {
        serviceBus.emit(
          serviceBusTopics.events.CART_FAILURE
        );
      }
    });
  };

  function waitForServiceBus(callback) {
    var isServiceBusValid = window.GlobalServiceBus && window.GlobalServiceBus.emit;
    var isServiceBusTopicsValid = window.ServiceBusTopics && window.ServiceBusTopics.events;

    if (isServiceBusValid && isServiceBusTopicsValid) {
      callback();
    } else {
      setTimeout(function () {
        waitForServiceBus(callback);
      }, 50);
    }
  }

  $(document).ready(function () {
    waitForServiceBus(initAddCart);
  });
})(jQuery);
